import { fromJS } from 'immutable';

export function request(state) {
    return state.set('bonuses', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { bonuses }) {
    return state.set('bonuses', fromJS({
        status: 'FINISHED',
        items: bonuses
    }));
}

export function error(state) {
    return state.set('bonuses', fromJS({
        status: 'ERROR'
    }));
}
